const landingRoot = document.querySelector('[data-despeja-page]');
if (!landingRoot) throw new Error('No se encontró la landing Despeja el camino');
landingRoot.querySelectorAll('.ecdg-slider').forEach(slider => {
  slider.tabIndex = 0;
  slider.setAttribute('aria-label', 'Galería de testimonios. Usa las flechas para desplazarte.');
  slider.addEventListener('keydown', event => {
    if (event.target !== slider || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    slider.scrollBy({left: slider.clientWidth * (event.key === 'ArrowRight' ? .8 : -.8), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  });
});
const modal = document.createElement('dialog');
modal.className = 'image-dialog';
modal.setAttribute('aria-label','Testimonio ampliado');
const close = document.createElement('button'); close.textContent = '×'; close.setAttribute('aria-label','Cerrar imagen');
const photo = document.createElement('img');
modal.append(close,photo); landingRoot.append(modal);
close.addEventListener('click',()=>modal.close());
modal.addEventListener('click',e=>{if(e.target===modal)modal.close();});
landingRoot.querySelectorAll('.ecdg-testimonial__media a').forEach(link=>link.addEventListener('click',event=>{
  if(!/\.(jpg|jpeg|png|webp)(\?|$)/i.test(link.href))return;
  event.preventDefault(); photo.src=link.href; photo.alt=link.querySelector('img')?.alt || 'Testimonio'; modal.showModal();
}));

const ctaLabel = landingRoot?.dataset.ctaLabel || 'Solicitar acceso al programa';
landingRoot.querySelectorAll('.ecdg-school-button, .ecdg-whatsapp').forEach((cta)=>{
  if (cta.closest('#como-empezar')) return;
  cta.textContent = ctaLabel;
  cta.setAttribute('href','#como-empezar'); cta.removeAttribute('target'); cta.removeAttribute('rel');
  cta.addEventListener('click',(event)=>{
    event.preventDefault();
    document.getElementById('como-empezar')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  });
});
(function isolateLanding(){
  var root=document.querySelector('[data-despeja-page]');
  if(!root){setTimeout(isolateLanding,80);return;}
  var pageContainer=root.closest('main')||root.parentElement;
  if(pageContainer)pageContainer.style.cssText+=';margin:0!important;padding:0!important;max-width:none!important;width:100%!important;';
  var keep=root;
  while(keep.parentElement&&keep.parentElement!==document.body)keep=keep.parentElement;
  Array.prototype.forEach.call(document.body.children,function(node){
    if(node!==keep&&node.tagName!=='SCRIPT'&&node.tagName!=='STYLE')node.style.setProperty('display','none','important');
  });
  document.documentElement.style.background='#08090c';
  document.body.style.cssText+=';margin:0!important;background:#08090c!important;';
})();
